import axios from "axios";

const apiEndpoint =
  process.env.REACT_APP_API_ENDPOINT || "https://rewrite-backend.vercel.app/";

const authApi = axios.create({
  baseURL: `${apiEndpoint}api-user`,
  /* withCredentials: true, */
});

export const login = (user) => authApi.post("/login", user);

export const resetPassword = (data) => authApi.post("/reset-password", data);

export const forgotPassword = (data) => authApi.post("/forgot-password", data);

export const signup = (user) => authApi.post("/register-user", user);

export const logout = () => authApi.post("/logout");

export const getUser = () => authApi.get("/");

// Borrado de cuenta self-service (Apple Guideline 5.1.1(v)). Re-autentica con
// email + contraseña (el backend re-verifica la contraseña antes de borrar el
// usuario y su progreso en cascada).
export const deleteAccount = (email, password) =>
  authApi.post("/delete-account", { email, password });
